export default __webpack_public_path__ + "static/media/bg-valdano-bio-01@3x.67b40617.jpg";